module.exports = require("lru-cache");


//////////////////
// WEBPACK FOOTER
// external "lru-cache"
// module id = 12
// module chunks = 0